export function isGroupWithMembers(g) {
    return Boolean('members' in g && g.members && 'memberUuids' in g && g.memberUuids);
}
//# sourceMappingURL=groups.js.map